import { useTheme } from 'styled-components';

import { defaultTheme } from 'helpers/styles/themes';

export function useStyledTheme() {
  const theme = useTheme();

  return theme || defaultTheme;
}
